module.exports = __webpack_public_path__ + "img/IMG_BackGroundTest50Fichier 46.0aa22b7f.png";